import { render, staticRenderFns } from "./ThumbnailTooltip.vue?vue&type=template&id=508f918c&"
import script from "./ThumbnailTooltip.vue?vue&type=script&lang=js&"
export * from "./ThumbnailTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BPopover} from 'bootstrap-vue'
    installComponents(component, {BPopover})
    

export default component.exports